import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09bd9871"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wallet_summary"
}
const _hoisted_2 = { class: "bank__select" }
const _hoisted_3 = { class: "amount_details" }
const _hoisted_4 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }
const _hoisted_5 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_6 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }, " Subtotal (include Grant) ", -1))
const _hoisted_8 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }, " vat ", -1))
const _hoisted_11 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_13 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }
const _hoisted_14 = { class: "tw-text-xs tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_15 = { class: "tw-flex tw-items-center tw-justify-between tw-my-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-lg tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0C0F4A]" }, " Total ", -1))
const _hoisted_17 = { class: "tw-text-lg tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#0C0F4A]" }
const _hoisted_18 = { class: "confirm_wrapper tw-mt-8" }
const _hoisted_19 = { class: "confirm_wrapper_issue tw-flex tw-items-center tw-gap-2 md:tw-flex-col md:tw-items-start" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-tracking-[0.25px] tw-leading-[22px] tw-font-medium tw-text-[#0c0f4a80]" }, " Can’t Find Your Bank? ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-6 tw-text-[10px] tw-tracking-[0.25px] tw-leading-[18px] tw-font-medium tw-text-[#0c0f4a80] tw-text-center" }, [
  /*#__PURE__*/_createTextVNode(" By agreeing and continuing you consent to us requesting funds from your selected bank and sharing your account details with them. "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#0c0f4a]" }, "Terms & conditions"),
  /*#__PURE__*/_createTextVNode(" apply. You will be redirect to your bank app for payment. ")
], -1))

import {
  computed,
  ComputedRef,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import CommonDialog from "@/core/components/CommonDialog.vue";
import CommonLoader from "@/core/components/CommonLoader.vue";
import CurrencyFilter from "@/filters/currency.filter";
import { EscrowStatusEnum, EstimatePhaseType } from "@/core/enums/estimateEnum";
import { ProjectPhaseType } from "@/core/enums/ProjectsEnum";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import Button from "@/core/components/ui/general/Button.vue";
const SERVICE_CHARGE = 0.03;
const PHASE_FIRST_CHARGE = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'EscrowSelectBankModal',
  props: {
  selectedPhases: {
    type: Array,
  },
  subTotalAmount: {
    type: Number,
  },
  vatTotal: {
    type: Number,
  },
  projectDetails: {
    type: Object,
  },
  estimateDetails: {
    type: Object,
  },
},
  emits: ["on-close", "on-redirect-EWallet", "on-confirm"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const formValid = ref(false);
const props = __props;
const bankList = ref([]);

const phaseEstimateType = (phase: any) => {
  if (phase?.phaseType === ProjectPhaseType.MATERIAL) return "Materials";
  else return phase?.name;
};
const formattedCurrency = (value: any, flag = false) => {
  const formattedAmt = CurrencyFilter.formatToCurrency(value);
  if (flag) return `-${formattedAmt}`;
  return formattedAmt;
};
const selectedBank = ref(null);
const loading = ref(false);
const onClickBackButton = () => {
  emits("on-close");
};

const onConfirm = async () => {
  if (formValid.value) {
    const projectPhaseDeposits = props.selectedPhases.map((phase) => {
      return { projectPhaseId: phase?.id };
    });

    const payload = {
      aspspId: selectedBank.value,
      projectId: props.projectDetails?.id,
      projectPhaseDeposits,
    };

    console.log("payload :>> ", payload);
    emits("on-confirm", payload);
  }
};
const onRedirectEWallet = () => {
  emits("on-redirect-EWallet");
};
const filterBankList = computed(() => {
  return bankList.value.filter((bank) => {
    return bank.capabilities.every((data: any) => data.status === "ENABLED");
  });
});
const totalPhaseTasks = computed(
  () =>
    props.estimateDetails?.estimationPhase.filter(
      (phase: any) => phase.phaseType === EstimatePhaseType.LABOUR
    ).length
);
const totalPhaseAmount = (
  phaseType: EstimatePhaseType,
  amount: number,
  vat: number,
  isFirstPhase: boolean,
  phaseDetails: any
) => {
  let sum = 0;
  // let vatSum = amount * vat;
  let phaseCost = amount;
  const isUpdateChangePhaseAmount =
    [EscrowStatusEnum.IN_PROGRESS, EscrowStatusEnum.IN_PROGRESS_POKED].includes(
      phaseDetails?.escrowStatus?.id
    ) && parseFloat(phaseDetails?.updatedSubTotal) > 0;
  if (isUpdateChangePhaseAmount) {
    phaseCost = parseFloat(phaseDetails?.updatedSubTotal);
  }
  let serviceCost = phaseCost * SERVICE_CHARGE;
  sum += serviceCost + phaseCost;
  if (phaseDetails?.isOld) {
    sum += PHASE_FIRST_CHARGE;
  }

  if (phaseType === EstimatePhaseType.LABOUR && totalPhaseTasks) {
    const grantAmount: number = parseFloat(props.estimateDetails?.grantAmount);
    const totalTasks: number = parseFloat(totalPhaseTasks.value);
    const grantDiscountTotal = grantAmount / totalTasks;
    const finalAmount = sum - grantDiscountTotal;
    return Math.floor(finalAmount * 100) / 100;
  }
  return formattedCurrency(sum);
};
onMounted(async () => {
  try {
    loading.value = true;
    bankList.value = await tradeEstimateService.getEscrowBankProviders();
  } catch (error) {
    console.log(error);
    onClickBackButton();
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    HeaderTittle: "Pay Money Into Your Escrow Wallet",
    title: "Select your bank",
    className: ['escrow_pay_money_wallet'],
    width: "510px",
    onClickBackButton: onClickBackButton
  }, _createSlots({
    body: _withCtx(() => [
      _createVNode(CommonLoader, {
        loading: loading.value,
        class: "escrow-loader-container"
      }, null, 8, ["loading"]),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_form, {
              ref: "form",
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValid).value = $event)),
              class: "tw-max-w-full tw-mt-6 md:tw-mt-4",
              onSubmit: _withModifiers(onConfirm, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_autocomplete, {
                    variant: "underlined",
                    modelValue: selectedBank.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBank).value = $event)),
                    items: filterBankList.value,
                    "item-title": "name",
                    "item-value": "id",
                    placeholder: "Type or select by clicking the arrow",
                    rules: [(v) => !!v || 'Bank  is required'],
                    required: "",
                    class: "custom_selector",
                    "menu-props": { contentClass: 'text_selector' }
                  }, null, 8, ["modelValue", "items", "rules"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedPhases, (phase) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: phase?.id,
                      class: "tw-flex tw-items-center tw-justify-between tw-my-2"
                    }, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(phaseEstimateType(phase)), 1),
                      _createElementVNode("strong", _hoisted_5, _toDisplayString(totalPhaseAmount(
                    phase?.phaseType,
                    phase?.subTotal,
                    phase?.vat,
                    phase?.isOld,
                    phase
                  )), 1)
                    ]))
                  }), 128)),
                  _createVNode(_component_v_divider, { thickness: 1 }),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("strong", _hoisted_8, _toDisplayString(formattedCurrency(__props.subTotalAmount)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("strong", _hoisted_11, _toDisplayString(formattedCurrency(__props.vatTotal)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(__props.estimateDetails?.grantName
                    ? __props.estimateDetails?.grantName
                    : "Grant "), 1),
                    _createElementVNode("strong", _hoisted_14, _toDisplayString(formattedCurrency(__props.estimateDetails?.grantAmount, true)), 1)
                  ]),
                  _createVNode(_component_v_divider, { thickness: 1 }),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("strong", _hoisted_17, _toDisplayString(formattedCurrency(__props.subTotalAmount + __props.vatTotal)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", {
                      onClick: onRedirectEWallet,
                      class: "tw-text-sm tw-tracking-[0.25px] tw-leading-[22px] tw-font-bold tw-text-[#3366FF] tw-cursor-pointer"
                    }, [
                      _createTextVNode("Transfer Manually "),
                      _createVNode(_component_v_icon, {
                        icon: "mdi-chevron-right",
                        class: "tw-text-[#3366FF]"
                      })
                    ])
                  ]),
                  _createVNode(Button, {
                    variant: "accent",
                    type: "submit",
                    label: "Confirm",
                    class: "tw-mt-8"
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (!loading.value)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _hoisted_21
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})